<template>
  <div>
    <div class="grid grid-cols-2 gap-4 my-2">
      <label class="font-bold text-gray-900">Assureur</label>
      <label class="font-bold text-gray-900">Période</label>
    </div>
    <div class="grid grid-cols-2 gap-4 mt-2" v-for="insurer in insurers" :key="insurer.id">
      <span>
        {{ insurer.name }}
      </span>
      <MonthlyDateFilterSelector
        :key="insurer.id"
        placeholder="Sélectionner une période"
        @newDateSelected="(startDate, endDate) => updateDateFilters(insurer, startDate, endDate)"
      />
    </div>
    <div class="mt-4 flex justify-end">
      <Loading v-if="isLoading" />
      <GenericButton v-else @click="submit">Exporter</GenericButton>
    </div>
  </div>
</template>
<script>
import { Loading, GenericButton, toSnakeCase, download } from "@estaly/ui";
import MonthlyDateFilterSelector from "@/components/menu/MonthlyDateFilterSelector.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    GenericButton,
    Loading,
    MonthlyDateFilterSelector,
  },

  emits: ["success"],

  data: () => {
    return {
      isLoading: false,
      payload: {},
    };
  },

  computed: {
    ...mapGetters("insurers", { insurers: "getIndex" }),
  },

  created() {
    this.loadInsurers();
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("insurers", { fetchInsurers: "fetchIndex" }),
    ...mapActions("insurerReportings", ["downloadQontoBulkTransferCSV"]),

    async loadInsurers() {
      this.isLoading = true;
      await this.fetchInsurers();
      this.isLoading = false;
    },

    async updateDateFilters(insurer, startDate, endDate) {
      this.payload[insurer.id] = { startDate, endDate };
    },

    async submit() {
      this.isLoading = true;
      const periods = Object.entries(this.payload).map(([insurerId, { startDate, endDate }]) =>
        toSnakeCase({
          insurer: insurerId,
          startDate,
          endDate,
        }),
      );
      const response = await this.downloadQontoBulkTransferCSV({ periods });
      this.isLoading = false;
      if (!response?.success) return;
      if (response?.status === 204) {
        return this.notify({
          category: "simple",
          type: "error",
          title: "No data found for the selected period.",
        });
      }

      download(response.data, "qonto_bulk_transfer.csv");
      this.$emit("success");
    },
  },
};
</script>
